module.exports = __webpack_public_path__ + "img/image-jpeg.528edc9d.png";